import { render, staticRenderFns } from "./questionsModal.vue?vue&type=template&id=00939ef0&"
import script from "./questionsModal.vue?vue&type=script&lang=js&"
export * from "./questionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports